export default class SubscriptionPlanType {}

SubscriptionPlanType.Membership = 'MEMBERSHIP';
SubscriptionPlanType.PlusChat = 'PLUS_CHAT';
SubscriptionPlanType.Vfg = 'VFG';
SubscriptionPlanType.Vfw = 'VFW';
// Deprecated
SubscriptionPlanType.Wellness = 'WELLNESS';
